"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var app_1 = __importDefault(require("firebase/app"));
var AuthService = (function () {
    function AuthService() {
        this.isInitialized = false;
        this.signedIn = false;
    }
    AuthService.prototype.initialize = function () {
        var _this = this;
        app_1.default.auth().useDeviceLanguage();
        this.googleProvider = new app_1.default.auth.GoogleAuthProvider();
        this.facebookProvider = new app_1.default.auth.FacebookAuthProvider();
        return new Promise(function (resolve, reject) {
            app_1.default.auth().onAuthStateChanged(function (user) {
                if (user) {
                    _this.signedIn = true;
                    _this.userData = user;
                }
                else {
                    _this.signedIn = false;
                    _this.userData = null;
                }
                if (!_this.isInitialized) {
                    resolve(null);
                    _this.isInitialized = true;
                }
            });
        });
    };
    AuthService.prototype.isSignedIn = function () {
        return this.signedIn;
    };
    AuthService.prototype.isSignedInAsAdmin = function () {
        return this.signedIn && this.userData.email === 'albertodlh@gmail.com';
    };
    AuthService.prototype.getCurrentUser = function () {
        return this.userData;
    };
    AuthService.prototype.signInWithGoogle = function () {
        return __awaiter(this, void 0, void 0, function () {
            var signInResult, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isInitialized || this.signedIn)
                            return [2, false];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, app_1.default.auth().signInWithPopup(this.googleProvider)];
                    case 2:
                        signInResult = _a.sent();
                        this.userData = signInResult.user;
                        return [2, signInResult];
                    case 3:
                        err_1 = _a.sent();
                        debugger;
                        return [2, false];
                    case 4: return [2];
                }
            });
        });
    };
    AuthService.prototype.signInWithFacebook = function () {
        return __awaiter(this, void 0, void 0, function () {
            var signInResult, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isInitialized || this.signedIn)
                            return [2, false];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, app_1.default.auth().signInWithPopup(this.facebookProvider)];
                    case 2:
                        signInResult = _a.sent();
                        console.log(signInResult);
                        this.userData = signInResult.user;
                        return [2, true];
                    case 3:
                        err_2 = _a.sent();
                        console.log(err_2);
                        return [2, false];
                    case 4: return [2];
                }
            });
        });
    };
    AuthService.prototype.signOut = function () {
        return __awaiter(this, void 0, void 0, function () {
            var signOutResult, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isInitialized || !this.signedIn)
                            return [2, false];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, app_1.default.auth().signOut()];
                    case 2:
                        signOutResult = _a.sent();
                        console.log(signOutResult);
                        return [2, true];
                    case 3:
                        err_3 = _a.sent();
                        console.log(err_3);
                        return [2, false];
                    case 4: return [2];
                }
            });
        });
    };
    return AuthService;
}());
exports.default = new AuthService();
